import {privacyPolicy} from '@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks';

export default {
    props: {
        organizationPrivacyPolicyUrl: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        privacyPolicyUrl() {
            if (this.organizationPrivacyPolicyUrl) {
                return this.organizationPrivacyPolicyUrl;
            }

            return privacyPolicy;
        },
    },
};
